import { Job } from "~/components/build/Show/lib/types";

export function isJobIgnored(job: Job): boolean {
  return job.state === "skipped" || job.state === "broken";
}
